export const InitialFormProduction = {
  product: [],
  vendor: [],
  mold: [],
};

export const InitialFormProductionTable = {
  gemany: [],
  burnt_and_bubble: [],
  broken_edge: [],
  poor_leaf: [],
  nepali_total: [],
  germany_total: [],
};
